import { Trash2 } from 'lucide-react'
import { useMemo } from 'react'
import { createColumnHelper, type ColumnDef } from '@tanstack/react-table'

import Button from '@/elements/Button'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import { defaultColumnOptions, type TableAny } from '@/utils/tables'
import type { ExclusionWordResponse } from '@/api/types/Organization'

interface ExclusionWordTableType {
  id: string
  word: string
}

const columnHelper = createColumnHelper<ExclusionWordTableType>()

export function useExclusionWordsTable(
  exclusionWords: ExclusionWordResponse[],
  onRemoveExclusionWord: (id: string) => void
) {
  const data: ExclusionWordTableType[] = useMemo(() => (
    exclusionWords.map(e => ({
      id: e.id,
      word: e.word,
    }))
  ), [exclusionWords])

  const columns: ColumnDef<ExclusionWordTableType, TableAny>[] = [
    columnHelper.accessor('word', {
      ...defaultColumnOptions,
      header: 'Exclusion Word',
      enableSorting: false,
      cell: info => (
        <Flex className='user-cell'>
          <Text variant='textblock'>{info.getValue() as string}</Text>
        </Flex>
      ),
    }),
    columnHelper.display({
      id: 'actions',
      ...defaultColumnOptions(),
      header: 'Actions',
      meta: { width: 75 },
      enableSorting: false,
      cell: info => {
        const exclusionWordId = info.row.original.id
        return (
          <Flex justify='center' align='center' className='actions-cell'>
            <Button
              small
              variant='iconDangerBtn'
              onClick={() => onRemoveExclusionWord(exclusionWordId)}
            >
              <Trash2 size={18} />
            </Button>
          </Flex>
        )
      }
    }),
  ]

  return { data, columns }
}
